module.exports = __webpack_public_path__ + "components/rewards-header/static/background-e60e2aeb3be76a35f4fe7e776b89d1bd.mp4";